import React from 'react';

import { Chip } from '@mui/material';

interface Props {
  markup: number | null;
  rateType: string | null;
}

export default function MissingBadge({ markup, rateType }: Props) {
  const missing: string[] = [];
  if (markup == null) missing.push('markup');
  if (rateType == null) missing.push('rate type');

  if (missing.length === 0) {
    return (
      <Chip label="✓ complete" size="small" sx={{ height: 20, fontSize: 11, bgcolor: '#e8f5e9', color: '#2e7d32' }} />
    );
  }

  return (
    <Chip
      label={`missing: ${missing.join(', ')}`}
      size="small"
      sx={{ height: 20, fontSize: 11, bgcolor: '#ffebee', color: '#c62828' }}
    />
  );
}
